module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KH-6c0f80d46a73ee5c71d7029b0ce158ee.png";